import { css, styled } from 'styled-components';

export const Container = styled.div`
  padding: 2rem 0;
`;

export const ContainerTypes = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export const ButtonType = styled.button<{ active: boolean }>`
  display: block;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.texts_light};
  padding: 0 0 0.6rem;
  border-bottom: 4px solid transparent;

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.colors.texts};
      border-color: ${({ theme }) => theme.colors.texts};
    `}
`;
